import { getClaimStatusBadgeColor } from "@/lib/care-history-utils";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Info } from "lucide-react";

type ClaimStatusBadgeProps = {
  revAdjudicationDesc: string;
  statusDefinition?: string;
};

const ClaimStatusBadge: React.FunctionComponent<ClaimStatusBadgeProps> = ({
  revAdjudicationDesc,
  statusDefinition,
}) => {
  const tooltip = statusDefinition;

  const badge = (
    <p
      className={`${getClaimStatusBadgeColor(revAdjudicationDesc)} inline-flex items-center justify-center gap-1 rounded px-3 py-1 text-sm font-semibold text-white shadow-lg ${tooltip ? "hover:cursor-help" : ""}`}
    >
      <span>{revAdjudicationDesc}</span>
      {tooltip ? <Info className="size-3" /> : null}
    </p>
  );

  if (!tooltip) {
    return badge;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>{badge}</TooltipTrigger>
      <TooltipContent>
        <p className="m-1 max-w-sm text-justify font-medium">{tooltip}</p>
      </TooltipContent>
    </Tooltip>
  );
};

export default ClaimStatusBadge;
